import { render } from "./LoadingMain.vue?vue&type=template&id=d625b52a"
import script from "./LoadingMain.vue?vue&type=script&lang=js"
export * from "./LoadingMain.vue?vue&type=script&lang=js"

import "./LoadingMain.vue?vue&type=style&index=0&id=d625b52a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__